import type { StateCardActionProps } from "./types";

export function StateCardAction({ children }: StateCardActionProps) {
  return <div className="mt-1">{children}</div>;
}
